var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighFive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "51px",
    viewBox: "0 0 54 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCF0-2-Feed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-Colleague-Profile",
    transform: "translate(-613.000000, -479.000000)",
    stroke: "#0F2B41",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-High-Fives-Other",
    transform: "translate(613.000000, 480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(39.568966, 21.879310) scale(-1, 1) rotate(-15.000000) translate(-39.568966, -21.879310) translate(26.068966, 4.655172)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99391308,28.4217672 C8.30284863,32.1895735 12.0105584,34.0482187 15.2305263,34.1344445 C16.8864282,34.1344445 18.9292109,33.5418791 21.3588742,32.3567482 C21.4468743,29.4228766 21.9238338,27.1422494 22.7897528,25.5148668 C25.8011285,19.855376 26.4028342,18.7120337 26.4028342,18.7120337 L26.775204,10.6409611 C26.775204,9.19341271 25.694333,8.02021918 24.3608814,8.02021918 C23.0274297,8.02021918 21.9456877,9.19341271 21.9456877,10.6409611 L21.9456877,16.8518319 L21.9456877,6.47512244 C21.9456877,5.02844504 20.8648167,3.85438055 19.5313651,3.85438055 C18.1979134,3.85438055 17.1170424,5.02844504 17.1170424,6.47512244 L17.1170424,15.7831545 L17.1170424,3.49118701 C17.1170424,2.04450962 16.0353005,0.870445124 14.7018488,0.870445124 C13.3683972,0.870445124 12.2875262,2.04450962 12.2875262,3.49118701 L12.2875262,15.7831545 L12.3075584,7.56209016 C12.3075584,6.11541276 11.2258165,4.94221924 9.89236481,4.94221924 C8.55891316,4.94221924 7.47804216,6.11541276 7.47804216,7.56209016 L7.47804216,20.2695093 L4.04120335,16.2909287 C3.64404204,15.7030255 2.97165493,15.3171868 2.20868716,15.3171868 C0.989332287,15.3171868 -8.70967713e-05,16.3066061 -8.70967713e-05,17.5259609 C-8.70967713e-05,17.8316706 0.0617516147,18.1217029 0.173235489,18.386477 L5.99391308,28.4217672 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47769389,20.2691602 L9.51401646,22.8280633 C12.3899519,22.4779343 14.4637261,22.9299665 16.0384358,24.8487084",
    id: "Stroke-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0382951,24.2135856 L18.0382951,14.9100495 C18.0382951,13.4642062 19.1185429,12.2925595 20.4512257,12.2925595 C21.784779,12.2925595 22.8650269,13.4642062 22.8650269,14.9100495 L22.8650269,25.2816469 L22.8650269,19.0743568 C22.8650269,17.6285135 23.9452747,16.4559964 25.2779575,16.4559964 C26.6106404,16.4559964 27.6917586,17.6285135 27.6917586,19.0743568 L27.6917586,30.7464298 C27.0841737,36.1172024 23.8051297,42.5534248 16.1528666,42.5534248 C12.9347552,42.4681192 9.22918312,40.6105457 6.92157879,36.845782 L1.1051276,26.8145367 C0.992837541,26.5516561 0.931034483,26.2609206 0.931034483,25.9562577 C0.931034483,24.7367354 1.91988341,23.7478865 3.13940573,23.7478865 C3.90106313,23.7478865 4.57306258,24.1335028 4.9699949,24.721067 L8.40485219,28.6964833 L8.40485219,15.9981315 C8.40485219,14.5505472 9.48510001,13.3789006 10.8186533,13.3789006 C12.1513362,13.3789006 13.231584,14.5505472 13.231584,15.9981315 L13.2115633,24.2135856 L13.2115633,11.9287049 C13.2115633,10.4828616 14.2918111,9.31034448 15.6253644,9.31034448 C16.9580472,9.31034448 18.0382951,10.4828616 18.0382951,11.9287049 L18.0382951,24.2135856 Z",
    id: "Stroke-1",
    strokeLinejoin: "round",
    transform: "translate(14.311397, 25.931885) rotate(-15.000000) translate(-14.311397, -25.931885) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(16.758621, 0.931034)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.35172414,6.18472883 L0,2.1945812",
    id: "Line-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7551724,6.18472883 L10.2413793,2.1945812",
    id: "Line-5",
    transform: "translate(11.637931, 4.189655) scale(-1, 1) translate(-11.637931, -4.189655) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98275862,5.58620669 L6.98275862,0",
    id: "Line-5",
    transform: "translate(6.982759, 2.793103) scale(-1, 1) translate(-6.982759, -2.793103) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.724138, 45.155171) rotate(-180.000000) translate(-30.724138, -45.155171) translate(24.206897, 41.896550)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.35172414,6.18472883 L0,2.1945812",
    id: "Line-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7551724,6.18472883 L10.2413793,2.1945812",
    id: "Line-5",
    transform: "translate(11.637931, 4.189655) scale(-1, 1) translate(-11.637931, -4.189655) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98275862,5.58620669 L6.98275862,0",
    id: "Line-5",
    transform: "translate(6.982759, 2.793103) scale(-1, 1) translate(-6.982759, -2.793103) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighFive);
export default __webpack_public_path__ + "static/media/highFive.6b9a5401d538ebe72b2e3811ed6ce6c2.svg";
export { ForwardRef as ReactComponent };